module.exports = __webpack_public_path__ + "img/logo.bec7b47b.png";